import { AppBreadcrumb, AppPagination, AppButton, AppContainer } from '@/components/atoms';
import { Download, Plus } from '@/components/atoms/AppIcon';
import RezeptSheetTable from '@/components/molecules/RezeptSheetTable';
import { useAdminTheme } from '@/shared/providers/admin-theme/AdminThemeContext';
import type { RezeptSheet } from '@/types/admin-rezept-sheet';
import type { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import type { SorterResult } from 'antd/es/table/interface';

interface AdminRezeptSheetListTemplateProps {
  data: RezeptSheet[];
  current: number;
  total: number;
  pageSize: number;
  sortInfo?: { columnKey?: string; order?: 'ascend' | 'descend' };
  isLoading?: boolean;
  onChange: (page: number) => void;
  onTableChange?: (sorter: SorterResult<RezeptSheet> | SorterResult<RezeptSheet>[]) => void;
  breadcrumbItems: BreadcrumbItemType[];
  onCreateClick?: () => void;
  onEditClick?: (id: number) => void;
  onCsvDownload?: () => void;
  csvLoading?: boolean;
}

const AdminRezeptSheetListTemplate = ({
  data,
  current,
  total,
  pageSize,
  sortInfo,
  isLoading,
  onChange,
  onTableChange,
  breadcrumbItems,
  onCreateClick,
  onEditClick,
  onCsvDownload,
  csvLoading,
}: AdminRezeptSheetListTemplateProps) => {
  const { colors } = useAdminTheme();

  const btnStyle = { backgroundColor: colors.primary, color: '#fff', borderColor: colors.primary };

  return (
    <AppContainer>
      <main className="space-y-5 px-4">
      <AppBreadcrumb items={breadcrumbItems} />
      <h3 className="text-xl">レセプト用紙</h3>

      {/* CSV download */}
      <div className="flex justify-center">
        <AppButton
          onClick={onCsvDownload}
          loading={csvLoading}
          icon={<Download />}
          style={btnStyle}
          className="py-2 my-4 btn-ra2-hover"
        >
          CSV
        </AppButton>
      </div>

      {/* 新規 button */}
      {onCreateClick && (
        <div>
          <AppButton icon={<Plus />} className="py-1 my-1" style={btnStyle} onClick={onCreateClick}>
            新規
          </AppButton>
        </div>
      )}

      {/* Table */}
      <div className="bg-white rounded-md border">
        <RezeptSheetTable
          data={data}
          sortInfo={sortInfo}
          isLoading={isLoading}
          onTableChange={onTableChange}
          onEditClick={onEditClick}
        />
        <div className="flex justify-end p-4">
          <AppPagination
            current={current}
            total={total}
            pageSize={pageSize}
            onChange={onChange}
            hideOnSinglePage
          />
        </div>
      </div>
    </main>
    </AppContainer>
  );
};

export default AdminRezeptSheetListTemplate;
